export const creditCard = 'TCR';
export const broker = 'AGE';
export const cashPayment = 'DCW';
export const achPayment = 'ACH';
export const clavePayment = 'CLA';
export const sinpePayment = 'WEB';
export const bankTransferPayment = 'EFT';

export type PaymentLegacy =
  | typeof creditCard
  | typeof broker
  | typeof achPayment
  | typeof cashPayment;
